import { FC, SVGAttributes } from 'react'

/**
 * The avatar menu's and the notifications tray's line icons (both brands): 24-unit strokes in
 * `currentColor`, so each takes its row's ink and flips with the theme. Brand-neutral — an app's
 * own rows may pass its own icon (`AuthMenuItem.icon`).
 */
type Icon = FC<SVGAttributes<SVGElement>>

function line(paths: JSX.Element, name: string): Icon {
  const LineIcon: Icon = props => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.9}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {paths}
    </svg>
  )
  LineIcon.displayName = name
  return LineIcon
}

export const BellIcon = line(
  <>
    <path d="M6 8a6 6 0 0 1 12 0v5l2 3H4l2-3z" />
    <path d="M10 20a2 2 0 0 0 4 0" />
  </>,
  'BellIcon'
)

export const GearIcon = line(
  <>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
  </>,
  'GearIcon'
)

export const MoonIcon = line(<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />, 'MoonIcon')

export const LogOutIcon = line(
  <>
    <path d="M10 17l5-5-5-5" />
    <path d="M4 12h11" />
    <path d="M20 4v16" />
  </>,
  'LogOutIcon'
)

export const PersonIcon = line(
  <>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
  </>,
  'PersonIcon'
)

export const ChevronLeftIcon = line(<path d="M15 18l-6-6 6-6" />, 'ChevronLeftIcon')

export const CheckIcon = line(<path d="M5 12l5 5L20 7" />, 'CheckIcon')

export const ChatIcon = line(
  <path d="M21 12a8 8 0 0 1-8 8H8l-5 3V12a8 8 0 0 1 8-8h2a8 8 0 0 1 8 8z" />,
  'ChatIcon'
)

export const HeartIcon = line(
  <path d="M12 21s-7-4.6-9.5-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 6c-2.5 4.4-9.5 9-9.5 9z" />,
  'HeartIcon'
)

export const StarIcon = line(
  <path d="M12 3l2.7 5.6 6.3.9-4.5 4.4 1 6.1L12 17l-5.5 3 1-6.1L3 9.5l6.3-.9z" />,
  'StarIcon'
)

export const PhoneIcon = line(
  <>
    <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
    <path d="M10.5 18h3" />
  </>,
  'PhoneIcon'
)
